<template>
  <layout-content>
    <i-button slot="top-buttons" size="large" type="primary" @click="add_senders">
      {{ $t('mailer.buttons.add_senders') }}
    </i-button>
    <filter-component />
    <table-component />
  </layout-content>
</template>

<script>
  import { mapActions } from 'vuex';
  import FilterComponent from '@mailer/components/senders/senders-filter';
  import TableComponent from '@mailer/components/senders/senders-table';
  import { SenderModalService } from '@mailer/modals/SenderModalService';

  export default {
    components: {
      FilterComponent,
      TableComponent
    },
    methods: {
      ...mapActions('mailer/senders/table', ['getAsyncData']),

      add_senders: function () {
        SenderModalService.create().on('success', () => {
          return this.getAsyncData()
        });
      }
    }
  };
</script>
